<template>
    <div class="gksj" v-loading.fullscreen.lock="loading">
        <p class="nowtime">{{ teamName }}公开时间为:{{ form.publicTime }}</p>
        <el-form ref="form" :model="form" label-width="80px" class="el-form">
            <el-form-item label="">
                <template v-if="allorTime">
                    <el-radio-group v-model="form.teamradio"
                                    @change="chooseDan"
                                    class="chooseTime">
                        <el-radio :label="2">部门</el-radio>
                        <el-radio :label="0">单位</el-radio>
                    </el-radio-group>
                </template>
                <el-date-picker v-model="form.publicTime"
                                type="date"
                                @change="changeTime"
                                placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <!--<el-form-item v-if="!allorTime" label="">
                <el-input v-model="form.name"></el-input>
            </el-form-item>-->
            <el-form-item style="text-align: center">
                <el-button type="primary" @click="onSubmit">点击修改</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import { postGksj, getGksj } from "@/api/zone.js";
    import { ElMessage } from "element-plus";

    export default {
        name: "Gksj",
        data() {
            return {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                // 部门或者单位
                teamName: "部门",
                // 表单内容
                form: {
                    // 单位名称
                    name: "",
                    // 部门或者单位
                    teamradio: 0,
                    // 当前选中时间
                    publicTime: "",
                },
                // 判断是更改单个时间还是所有时间，true是更改所有时间
                allorTime: true,
                // 部门时间
                buTime: "",
                // 单位时间
                danTime: "",
                //加载中按钮
                loading: false
            };
        },
        created() { },
        mounted() {
            this.companyJudge();
        },
        methods: {
            /**
             * 根据选择的单位或者部门切换时间
             */
            chooseDan(event) {
                if (event === 0) {
                    this.form.publicTime = this.danTime;
                    this.teamName = "单位";
                } else {
                    this.form.publicTime = this.buTime;
                    this.teamName = "部门";
                }
            },
            /**
             * 判断是从单位还是从部门进来的
             */
            companyJudge() {
                const that = this;
                this.loading = true
                this.init();

            },
            /**
             * 获取公开时间
             */
            init() {
                getGksj().then((res) => {
                    if (res.list.length > 0) {
                        this.form.publicTime = this.conversionTime(res.list[1].gksj);
                        this.form.teamradio = res.list[1].divtype;
                        if (res.list[1].divtype === 2) {
                            this.teamName = "部门";
                            this.danTime = this.conversionTime(res.list[0].gksj);
                            this.buTime = this.conversionTime(res.list[1].gksj);
                        } else {
                            this.teamName = "单位";
                            this.danTime = this.conversionTime(res.list[1].gksj);
                            this.buTime = this.conversionTime(res.list[0].gksj);
                        }
                    }
                    this.loading = false
                }).catch(err => {
                    this.loading = false
                })
            },
            /**
             * 修改部门时间
             */
            async modifyTime() {
                let res = await postGksj({
                    divtype: this.form.teamradio,
                    gksj: this.conversionTime(this.form.publicTime),
                });
                if (res.status == 0) {
                    ElMessage({
                        message: "修改成功",
                        type: "success",
                    });
                } else {
                    ElMessage({
                        message: "修改失败，请联系后台人员",
                        type: "error",
                    });
                }
            },
            /**
             * 时间改变
             */
            changeTime(event) {
                if (!event) {
                    this.form.publicTime = "";
                } else {
                    this.form.publicTime = this.conversionTime(event);
                }
            },
            /**
             * 表格提交事件
             */
            onSubmit() {
                if (!this.form.publicTime) {
                    ElMessage({
                        message: "请选择时间",
                        type: "error",
                    });
                    return;
                }
                this.modifyTime();
            },
        },
    };
</script>

<style scoped>
    .nowtime {
        width: 100%;
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 50px;
    }

    /deep/ .el-form-item .el-form-item__content {
        margin-left: 0 !important;
    }

    /deep/ .chooseTime {
        margin-right: 30px !important;
    }

    .gksj {
        width: 100%;
        padding: 50px;
        display: flex;
        /* 从上到下 */
        flex-direction: column;
        flex-wrap: wrap;
        /* 从y轴中间对齐 */
        justify-content: center;
        /* 从y轴开始的地方对齐 */
        justify-content: flex-start;
        align-items: center;
        align-content: center;
    }

    .modifyju {
        margin-left: 20px;
    }
</style>
